import React, { useState,useEffect } from 'react';
import FormInput from './FormInput';
import FormSelector from './FormSelector';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { PostApi } from '../../middleware/postMiddleware';
import ReCAPTCHA from 'react-google-recaptcha';
import { isTokenValid,getPayload } from '../../helpers/jwt';
import axios from 'axios';
import querystring from 'querystring';
import { TextField, Button, IconButton } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { getCart } from '../../helpers/cart';


function CheckOutForm({ title, heading, url }) {
    const history = useHistory();
    const [verified, setVerified] = useState(false);
    const [cityId, setCity] = useState('');
    const [message, setMessage] = useState("");
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemCount, setItemCount] = useState(3);

    const cart = getCart();


    const increaseItemCount = (e) => {
        e.preventDefault();
        if(itemCount >= 5 )
            return toast.error('Maximum 5 items can be added.');

        setItemCount(prev => ++prev);
    }




  const onChangeHandler = (e) => setMessage(e.target.value);

  const onFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter((file) =>
      file.size <= 5000000 && ["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    );

    if (validFiles.length !== selectedFiles.length) {
      toast.error("Some files are invalid or too large and have been excluded.");
    }

    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const removeFile = (index) => setFiles(files.filter((_, i) => i !== index));



    // ReCAPTCHA verification handler
    function onReCaptchaChange(value) {
        setVerified(!!value);
    }

    const validateForm = (event) => {
        const form = event.target;
        const requiredFields = ['FirstName', 'LastName', 'Company', 'Phone','Email','Country'];
        return requiredFields.every(field => form[field]?.value);
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        if (!validateForm(event)) {
            toast.error('Please fill in all required fields.');
            return;
        }

        setLoading(true);

        let customerId = null;
        if (isTokenValid("auth_token")) {
            customerId = getPayload("auth_token").id;
        }

        const formData = new FormData();

        // Append customer ID if available
        if (customerId) {
            formData.append("customerId", customerId);
        }

        // Append Billing Info
        formData.append("FirstName", event.target.FirstName.value);
        formData.append("LastName", event.target.LastName.value);
        formData.append("Company", event.target.Company.value);
        formData.append("Phone", event.target.Phone.value);
        formData.append("Email", event.target.Email.value);
        formData.append("Country", event.target.Country.value);
        formData.append("Industry", event.target.Industry.value);
        formData.append("Reference", event.target.Reference.value);
        formData.append("shippingMethod", event.target.shippingMethod.value);
        formData.append("paymentMethod", event.target.paymentMethod.value);
        formData.append("Message", message);


        // Append items (assuming a fixed number of 10 items)
        for (let i = 0; i < cart.length; i++) {
            formData.append(`Items[${i}][product_id]`, cart[i].product.product__ID);
            formData.append(`Items[${i}][product_quantity]`, cart[i].quantity);
        }


        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}${url}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (res.status === 200 && res.data.success) {
                toast.success('Response Sent Successfully');
                setTimeout(() => history.push('/'), 2500);
            } else {
                toast.error('Please Fill all the required data');
            }

        } catch (error) {
            console.error(error);
            toast.error('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer autoClose={3000} />
            <section className="contact-form-wrapper section-padding pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-left">
                            <h1>{heading}</h1>
                        </div>
                        <form onSubmit={onSubmitHandler} className="row contact-form">
                            {/* Billing Information */}
                            <div className='col-12 d-md-flex flex-md-wrap' style={{gap: '1rem'}}>
                                <FormInput label="* First Name" name="FirstName" />
                                <FormInput label="* Last Name" name="LastName" />
                                <FormInput label="* Company" name="Company" />
                                <FormInput label="* Phone Number" name="Phone" />
                                <FormInput label="* Email" name="Email" />
                                <FormSelector label="* Country" name="Country" setCity={setCity}/>
                                <FormInput label="Industry" name="Industry" />
                                <FormInput label="Reference a Previous Order or Invoice(Add Order or Invoice ID)" name="Reference" />
                            </div>
                            <div className="file-input-wrapper">
                                <label htmlFor="file-upload" className="theme-btn" style={{textTransform: "none"}}>Upload File(s)</label>
                                <input id="file-upload" type="file" onChange={onFileChange} multiple className="file-input" />
                            </div>
            
                            <div className="selected-files">
                                {files.map((file, index) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                    <span>{file.name}</span>
                                    <IconButton onClick={() => removeFile(index)} size="small" aria-label="remove" style={{ marginLeft: "5px" }}>
                                        <CloseIcon />
                                    </IconButton>
                                    </div>
                                ))}
                            </div>

                            {/* Shipping Method Dropdown */}
                            <div className="col-12 col-md-6 mt-3">
                                <h3>Choose Shipping Method:</h3>
                                <select name="shippingMethod" className="form-select">
                                    <option value="">Please select</option>
                                    <option value="UPS">UPS</option>
                                    <option value="Fedex">Fedex</option>
                                    <option value="DHL">DHL</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            {/* Payment Method Dropdown */}
                            <div className="col-12 col-md-6 mt-3">
                                <h3>Choose Payment Method:</h3>
                                <select name="paymentMethod" className="form-select">
                                    <option value="">Please select</option>
                                    <option value="Credit Card">Credit Card</option>
                                    <option value="COD">COD</option>
                                    <option value="Purchase Order">Purchase Order</option>
                                </select>
                            </div>
                            <div className='mt-5'>
                                <TextField
                                    // label= "* Comments"
                                    placeholder="Write here any additional information you want to describe to us."
                                    multiline
                                    rows={2}
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={message}
                                    onChange={onChangeHandler}
                                />
                            </div>

                            {/* ReCAPTCHA */}
                            <div className="col-12 my-4 text-center">
                                <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_KEY} onChange={onReCaptchaChange} />
                            </div>

                            {/* Submit Button */}
                            <div className="col-12 text-center">
                                <button 
                                    type="submit" 
                                    className="submit-btn" 
                                    // disabled={!verified}
                                >
                                    Check Out
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
             <style jsx>{`
                .file-input-wrapper {
                position: relative;
                display: inline-block;
                }
                .file-input {
                opacity: 0;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                cursor: pointer;
                }
            `}</style>
        </>
    );
}

export default CheckOutForm;
